export default __webpack_public_path__ + "static/media/avatar.31c8ef8b.svg";